goog.provide("shadow.js.shim.module$dayjs$locale$nl");
goog.provide("module$shadow_js_shim_module$dayjs$locale$nl");
shadow.js.shim.module$dayjs$locale$nl = shadow.js.nativeProvides["dayjs/locale/nl"] = require("dayjs/locale/nl");
module$shadow_js_shim_module$dayjs$locale$nl.default = shadow.js.shim.module$dayjs$locale$nl;
